import React from 'react';

import { useApexAdminPortalStateContext } from '../../ApexAdminPortalContext';
import View from './View';

const RequestedDocuments = () => {
  const { investigationResource } = useApexAdminPortalStateContext();
  const [documents, setDocuments] = React.useState([]);

  const refreshRows = () => {
    setDocuments(investigationResource?.attr('requestedDocuments'));
  };
  React.useEffect(() => {
    refreshRows();
  }, [investigationResource]);

  if (!investigationResource) {
    return null;
  }

  return (
    <View
      documents={documents}
    />
  );
};

RequestedDocuments.propTypes = {};

export default RequestedDocuments;
